/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramStaticPagesControllerFindOneByTypeQueryResponse,
  TelegramStaticPagesControllerFindOneByTypePathParams,
} from '../types/TelegramStaticPagesControllerFindOneByType.ts';

function getTelegramStaticPagesFindOneByTypeUrl(type: TelegramStaticPagesControllerFindOneByTypePathParams['type']) {
  const res = { method: 'GET', url: `/api/telegram/static-pages/${type}` as const };
  return res;
}

/**
 * {@link /api/telegram/static-pages/:type}
 */
export async function telegramStaticPagesFindOneByType(
  type: TelegramStaticPagesControllerFindOneByTypePathParams['type'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramStaticPagesControllerFindOneByTypeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramStaticPagesFindOneByTypeUrl(type).url.toString(), ...requestConfig });
  return res.data;
}
